import { CheckIcon, SearchIcon, Skeleton, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { generateClassesOfDropDown } from './drop-down-search.constants'

import styles from './drop-down-search.module.css'

import type { TransportCompanyProps } from '@/types'
import type { DropDownSearchProps } from './drop-down-search.type'

export const DropDownSearch = ({
  data,
  isOpen,
  isLoading,
  selected,
  onSelect,
  maxHeight,
}: DropDownSearchProps) => {
  const { t } = useTranslation('componentTransportCompanySearch')

  const classes = generateClassesOfDropDown(isOpen)

  const ItemLoading = () => (
    <li className={styles.item}>
      <Skeleton width="1.5rem" height="1.5rem" />

      <div className={styles.content}>
        <Skeleton width="100%" height="1.25rem" />

        <div className={styles.row}>
          <Skeleton width="6.25rem" height="1rem" />
          <Skeleton width="6.25rem" height="1rem" />
          <Skeleton width="6.25rem" height="1rem" />
        </div>
      </div>
    </li>
  )

  const Item = ({ name, ...rest }: TransportCompanyProps) => (
    <li className={styles['list-style']}>
      <button
        className={styles.item}
        onClick={() =>
          onSelect({
            name,
            ...rest,
          })
        }
      >
        <SearchIcon className={styles.icon} />

        <div className={styles.content}>
          <Text className={styles.title}>{name}</Text>
        </div>

        {selected?.uuid === rest?.uuid && <CheckIcon className={styles.icon} />}
      </button>
    </li>
  )

  if (isLoading) {
    return (
      <div className={classes} style={{ maxHeight }}>
        <ul className={styles.list}>
          <ItemLoading />
          <ItemLoading />
          <ItemLoading />
        </ul>
      </div>
    )
  }

  if (data && data?.length > 0) {
    return (
      <div className={classes} style={{ maxHeight }}>
        {data?.map((item) => <Item key={item?.uuid} {...item} />)}
      </div>
    )
  }

  return (
    <div className={classes} style={{ maxHeight }}>
      <Text className={styles.item}>{t('searchEngineEmptyResults')}</Text>
    </div>
  )
}
